import * as Three from 'three';
import React from 'react';

export default {

  render2D: function render2D(element, layer, scene) {
    var style = { stroke: element.selected ? '#000' : '#777', strokeWidth: "2px", fill: "white" };
    var width = element.properties.get('width').get('length');
    var depth = element.properties.get('depth').get('length');
    return React.createElement(
      'g',
      { transform: 'translate(' + -width / 2 + ',' + -depth / 2 + ')' },
      React.createElement('rect', { key: '1', x: '0', y: '0', width: width, height: depth, style: style }),
      React.createElement('line', { key: '2', x1: 0, y1: 0, x2: width, y2: depth, stroke: element.selected ? '#000' : '#777', strokeWidth: '2' }),
      React.createElement('line', { key: '3', x1: width, y1: 0, x2: 0, y2: depth, stroke: element.selected ? '#000' : '#777', strokeWidth: '2' })
    );
  },

  render3D: function render3D(element, layer, scene) {
    var mesh = new Three.Mesh();
    return Promise.resolve(mesh);
  }
};